import { Container, Row, Column } from '@algbra/ui/components/Grid/Grid'
import Icon from '@algbra/ui/components/Icon/Icon'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import {
  MEDIA_QUERY_MOBILE,
  useMediaQuery,
} from '@algbra/ui/hooks/useMediaQuery'
import { getIconByName } from '@algbra/ui/icons'
import { resolveAsImage } from '@algbra/ui/resolvers'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import Permalink from '@algbra/ui/components/Permalink/Permalink'
import React, { Fragment } from 'react'

import styles from './FeatureFullImage.module.scss'
import { VAlign } from '@algbra/ui/enums/align'

export type ZoneFeatureFullImageProps = {
  __typename: 'StrapiGQL_ComponentZonesFeatureFullImage'
  image: GatsbyResolvedAsset
  alt: string
}

export default function ZoneFeatureFullImage(props: ZoneFeatureFullImageProps) {
  const { alt, image } = props

  return (
    <Whitespace type="md">
      <Container>
        <Row vAlign={VAlign.STRETCH}>
          <Column size={12} lg={12} className={styles.itemContainer}>
            <GatsbyImage
              image={resolveAsImage(image)}
              alt=""
              className={styles.mobileImage}
              role="presentation"
              loading="lazy"
            />
          </Column>
        </Row>
      </Container>
    </Whitespace>
  )
}
